// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3PUQR","container":"styles_container__3nNl_","title":"styles_title__yrKvo","wrapper":"styles_wrapper__1J3vA","answer":"styles_answer__5bt2G"};